<template>
  <div class="table-wrapper">
    <el-table
      :data="data"
      stripe
      style="width: 100%"
      size="medium"
      header-row-class-name="common-table-header"
      row-class-name="common-table-row"
      class="is-print-hide common-table"
      :border="false"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
      <el-table-column prop="accountId" label="账户编号" width="170"></el-table-column>
      <el-table-column prop="merchantId" label="结算门店编号" width="120"></el-table-column>
      <el-table-column prop="customerName" label="结算门店名称" width="300">
        <template #default="{ row }">
          <el-tooltip effect="dark" :content="row.customerName" placement="top">
            <span>{{ row.customerName }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="accountAmount" label="余额(元)">
        <template #default="{ row }">
          <span>{{ row.accountAmount | fen2Yuan }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tr" label="代运营服务费扣点" width="140">
        <template #default="{ row }">
          <span>{{ row.tr }}%</span>
        </template>
      </el-table-column>
      <el-table-column prop="merchantStatus" label="状态" width="50">
        <template #default="{ row }">
          <span>{{ row.merchantStatus == 0 ? '启用' : '禁用' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
      <el-table-column label="操作">
        <template #default="{ row }">
          <span class="btn" @click="goViewDetail(row)">查看</span>
          <span class="btn" @click="toPay(row)">充值</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrapper">
      <el-pagination
        class="is-print-hide common-el-pagination"
        layout="prev, pager, next, total, jumper, sizes"
        :total="total"
        :current-page="pageNo"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        @current-change="val => $emit('handle-pageNo', val)"
        @size-change="val => $emit('handle-pageSize', val)"
      />
      <div class="sureJump global_common_button_goast">确定</div>
    </div>
  </div>
</template>

<script>
import Fetch from '@/api';

export default {
  name: 'drugsManagement',
  props: {
    data: {
      type: Array
    },
    total: {
      type: Number
    },
    pageNo: {
      type: Number
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array
    }
  },
  methods: {
    toPay(row) {
      this.$emit('pay', row);
    },
    goViewDetail(row) {
      this.$router.push(`/o2o/detail?accountId=${row.accountId}`);
    },
    handleSelectionChange(val) {
      this.$emit('selection-change', val);
    },
    selectable(row, index) {
      return row.merchantStatus == 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  color: #1e8dff;
  font-size: 12px;
  cursor: pointer;

  & + .btn {
    margin-left: 5px;
  }
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 22px;

  /deep/.el-pagination {
    margin-top: 0;
  }

  .sureJump {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    width: 80px;
    height: 32px;
    border-radius: 3px;
    cursor: pointer;
  }
}
</style>
